export default __webpack_public_path__ + "static/icon-plus-minus-c1b82fa405b061c7bfd295688d27cfaa.png";